export default {
  Title: 'Client leads',
  Action: 'Create new client lead',
  ClientLeadStatus: 'Client lead status: ',
  Filter: {
    Status: 'Status',
  },
};
